export enum Type {
  EDDY_PROJECT_POLL_REQUEST = 'app/eddy/EDDY_PROJECT_POLL_REQUEST',
  EDDY_PROJECT_POLL_SUCCESS = 'app/eddy/EDDY_PROJECT_POLL_SUCCESS',
  EDDY_PROJECT_POLL_UPDATE = 'app/eddy/EDDY_PROJECT_POLL_UPDATE',
  EDDY_PROJECT_POLL_FAILURE = 'app/eddy/EDDY_PROJECT_POLL_FAILURE',
  EDDY_PROJECT_POLL_CANCEL = 'app/eddy/EDDY_PROJECT_POLL_CANCEL',

  EDDY_PROJECT_CLEAR = 'app/eddy/EDDY_PROJECT_CLEAR',
}
